import { render, staticRenderFns } from "./LiveCard.vue?vue&type=template&id=3dc6e429&scoped=true&"
import script from "./LiveCard.vue?vue&type=script&lang=js&"
export * from "./LiveCard.vue?vue&type=script&lang=js&"
import style0 from "./LiveCard.vue?vue&type=style&index=0&id=3dc6e429&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6e429",
  null
  
)

export default component.exports